export const success = "#5cb85c";
export const info  = "#5bc0de";
export const warning = "#f0ad4e";
export const danger  = "#d9534f";